import { enableMapSet } from "immer";
enableMapSet();

import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import "bootstrap/dist/css/bootstrap.min.css";
import "sweetalert2/dist/sweetalert2.min.css";
import './assets/scss/fxbazzar.scss';
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { store } from "./Store/appStore";
import GlobalReduxToast from "./components/layout/ToastNotification";


const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <Provider store={store}>
    <BrowserRouter>
      <GlobalReduxToast />
      <App />
    </BrowserRouter>
  </Provider>
);
 
